// extracted by mini-css-extract-plugin
export var background = "styles-module--background--de79f";
export var bodyTitle = "styles-module--bodyTitle--28243";
export var button = "styles-module--button--662ff";
export var buttons = "styles-module--buttons--15dc8";
export var container = "styles-module--container--a9a4b";
export var content = "styles-module--content--aa4a1";
export var contentBody = "styles-module--contentBody--30c2a";
export var desktop = "styles-module--desktop--fd3e5";
export var item = "styles-module--item--540ed";
export var list = "styles-module--list--3c2ef";
export var phone = "styles-module--phone--d15ba";
export var small = "styles-module--small--947ea";
export var tablet = "styles-module--tablet--d8110";
export var title = "styles-module--title--2bfa0";
export var unorderedList = "styles-module--unorderedList--f6a1a";